export function formatNumber(n: number, options?: Intl.NumberFormatOptions, locales: Intl.LocalesArgument = "en-US")
{
    return new Intl.NumberFormat(locales, options).format(n);
}

export function formatDateTime(d: number | string | Date)
{
    if (typeof d !== "object")
        d = new Date(d);

    return d.toLocaleString("lt-LT");
}

export function preserveHtmlSpaces(s: string)
{
    return s.replaceAll("  ", " \u00a0");
}
